import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { isValid, startOfDay } from "date-fns";

// mirrors ALLOWED_STATES in agamotto-upload-ms/utils/const.ts
const STATE_MACHINE_OPTIONS = [
  "IDLE",
  "BOOTING",
  "UPDATING",
  "CAPTURING",
  "ALG_UPDATING",
  "OFF",
];

// MUI fires onChange on every keystroke, handing back an Invalid Date until the
// typed input is complete. Letting that through puts NaN in the filter, which
// blanks the table and fires a redundant unfiltered fetch mid-typing. A falsy
// value is the picker being cleared, which is a real change.
const isIncomplete = (d) => !!d && !isValid(d);

const dayStart = (d) => (d ? startOfDay(d).getTime() : null);

const FleetFilters = ({
  updatedFrom,
  updatedTo,
  stateMachine,
  onUpdatedRangeChange,
  onStateMachineChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <DatePicker
        label="Last alert from"
        value={updatedFrom ? new Date(updatedFrom) : null}
        maxDate={updatedTo ? new Date(updatedTo) : undefined}
        onChange={(d) => {
          if (isIncomplete(d)) {
            return;
          }
          onUpdatedRangeChange({ from: dayStart(d), to: updatedTo });
        }}
        format="MM/dd/yyyy"
        slotProps={{ textField: { size: "small" }, field: { clearable: true } }}
      />
      <DatePicker
        label="Last alert to"
        value={updatedTo ? new Date(updatedTo) : null}
        minDate={updatedFrom ? new Date(updatedFrom) : undefined}
        onChange={(d) => {
          if (isIncomplete(d)) {
            return;
          }
          onUpdatedRangeChange({ from: updatedFrom, to: dayStart(d) });
        }}
        format="MM/dd/yyyy"
        slotProps={{ textField: { size: "small" }, field: { clearable: true } }}
      />
      <TextField
        select
        size="small"
        label="State"
        value={stateMachine}
        onChange={(e) => onStateMachineChange(e.target.value)}
        sx={{ minWidth: "8rem" }}
      >
        <MenuItem value="">All</MenuItem>
        {STATE_MACHINE_OPTIONS.map((state) => (
          <MenuItem key={state} value={state}>
            {state}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default FleetFilters;
